
import { defineComponent, ref, watch, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "course-filter-modal",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ["close", "apply"],
  setup(props, { emit }) {
    const store = useStore();
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
    
    const filters = ref({
      name: "",
      types: [] as string[]
    });

    const closeModal = () => {
      emit("close");
    };

    const applyFilters = () => {
      emit("apply", filters.value);
    };

    // Load saved filters when modal opens
    watch(() => props.isOpen, (newVal) => {
      if (newVal) {
        // Carregar filtros salvos do store quando o modal abre
        const savedFilters = store.getters.getCourseFilters;
        filters.value = {
          name: savedFilters?.name || "",
          types: savedFilters?.types ? [...savedFilters.types] : []
        };
      }
    });

    return {
      filters,
      currentLanguage,
      closeModal,
      applyFilters
    };
  }
});
